import { Stack, Typography } from '@mui/material'
import { DataGrid } from 'Components/LifeDataGrid'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { convertToUserDateFormate } from 'utils/helpers'

function ListBottom({ operations, setEventF }) {
  const siteUser = useSelector((store) => store.user)

  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },

    {
      field: 'EstimatedDate',
      headerName: 'Date',
      width: 110,
      editable: false,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.EstimatedDate),
    },

    {
      field: 'MaintenanceOperation',
      headerName: 'Opérations',
      width: 350,
      editable: true,
      // valueGetter: (params) => `${params.row.Marques.Marque}`,
    },
  ]

  return (
    <div
      style={{
        marginTop: '20px',
        height: 350,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        Entretien à planifier ({operations.count})
      </Typography>

      <DataGrid
        sx={{ height: '85%', '.MuiDataGrid-footerContainer': { display: 'none' } }}
        rows={operations.results ? operations.results : []}
        columns={columns}
        // pageSize={rows}
        // rowCount={operations.count ? operations.count : 0}
        // onPageSizeChange={handleRowsChange}
        // onPageChange={handlePageChange}
        // rowsPerPageOptions={[ 10, 20, 40, 80, 100 ]}
        // pagination
        // onSelectionModelChange={itm => setSelectedRows( [ ...itm ] )}
        // paginationMode='server'
        // disableSelectionOnClick
        // checkboxSelection
        // disableSelectionOnClick
        onRowClick={(e) => setEventF(e.row)}

        // onRowClick={(params, event) => {
        //   if (event.target.localName === 'div') {
        //     // window.open(params.row.Lien)
        //     navigate(`/domicile/vehicule/{}`)

        //   }
        // }}
      />
    </div>
  )
}
export default ListBottom
